export default {
  sm: `
    PROVEN 
    GLOBAL
    INFRA
    STRUCTURE
  `,
  md: `
    PROVEN GLOBAL
    INFRASTRUCTURE
  `,
};
